import {Component} from 'react';

import {Box, ButtonBase, Stack, Typography} from '@mui/material';

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: null};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true, error};
    }

    handleReset = () => {
        this.setState({hasError: false, error: null});
    };

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    minHeight: 300,
                    padding: 4,
                }}>
                <Stack alignItems="center" gap="16px" sx={{maxWidth: 420, textAlign: 'center'}}>
                    <Typography sx={{fontSize: 18, fontWeight: 700, color: 'var(--cg-ink)'}}>
                        Something went wrong
                    </Typography>
                    <Typography sx={{fontSize: 13, color: 'var(--cg-text-soft)', lineHeight: 1.6}}>
                        {this.state.error?.message || 'An unexpected error occurred in this section.'}
                    </Typography>
                    <ButtonBase
                        onClick={this.handleReset}
                        sx={{
                            border: '1px solid var(--cg-border)',
                            background: 'var(--cg-surface)',
                            color: 'var(--cg-ink)',
                            borderRadius: '10px',
                            padding: '8px 20px',
                            fontFamily: 'inherit',
                            fontWeight: 700,
                            fontSize: 13,
                            cursor: 'pointer',
                        }}>
                        Try again
                    </ButtonBase>
                </Stack>
            </Box>
        );
    }
}
